import React from 'react';
import { FadeIn } from './FadeIn';
import { PricingSelector } from './PricingSelector';
export function FinalCTA() {
  return <section className="py-14 px-4 max-w-4xl mx-auto text-center pt-[0px] pb-[0px]" data-id="element-130">
      <FadeIn data-id="element-131">
        <div className="bg-[#020617] rounded-[2.5rem] p-6 md:p-12 border border-[#22c55e]/30 shadow-[0_20px_50px_rgba(2,6,23,0.15)] relative overflow-hidden" data-id="element-132">
          <div className="absolute inset-0 opacity-[0.05] bg-[radial-gradient(#22c55e_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-133"></div>

          <div className="relative z-10" data-id="element-134">
            <h2 className="md:text-5xl font-black mb-2 text-transparent bg-clip-text bg-gradient-to-r from-white to-[#e2e8f0] text-[26px]" data-id="element-135">
              Sí, quiero dejar de estar estancado. 🏃
            </h2>
            <p className="text-[#94a3b8] font-medium text-sm md:text-base mb-8 max-w-xl mx-auto" data-id="element-136">
              Hacé clic ahora y en menos de 2 minutos tenés todo el sistema en
              tus manos.
            </p>

            <PricingSelector variant="dark" data-id="element-137" />

            <p className="text-[#94a3b8] font-medium text-xs md:text-sm mt-6 italic" data-id="element-138">
              Cada kilómetro que corrés sin sistema es tiempo que no volvés a
              recuperar.
            </p>
          </div>
        </div>
      </FadeIn>
    </section>;
}